export default "__VITE_ASSET__85205ea6__"